import { useState, useEffect, useRef } from 'react';
import { Box, makeStyles, Button, Tooltip, TextField, IconButton } from '@material-ui/core';
import clsx from 'clsx';
import { useSelector } from 'react-redux';
import { DragDropContext, Droppable, Draggable } from 'react-beautiful-dnd';
import CSVReader from 'react-csv-reader'
import CustomSnackBar from './../../../../creator/experienceManager/participantsDashboard/component/CustomSnackBar';
import { CSVLink } from "react-csv";
import Messages from "../../../../../../helper/messages"

const useStyles = makeStyles(() => ({
  optionText: {
    color: '#697683',
    fontSize: 30,
    textAlign: 'center',
    fontWeight: 'lighter',
    marginTop: -25,
  },
  info: {
    color: '#697683',
    fontSize: 18,
    maxWidth: 570
  },
  titleBox: {
    display: 'flex',
    flex: 1,
    justifyContent: 'center'
  },
  title: {
    color: '#212D40',
    fontSize: 22,
    fontWeight: 'bold',
  },
  table: {
    border: '17px solid #FFE9C4',
    borderRadius: 17,
    width: 380,
    marginLeft: 12
  },
  tr: {
    display: 'flex',
    flexDirection: 'row',
    position: 'relative',
    backgroundColor: '#fff'
  },
  td: {
    border: '1px solid #707070',
    height: 34,
    padding: 5,
    display: 'flex',
    flex: 1,
    fontFamily: 'roboto-regular',
    alignItems: 'center',
    color: '#717E8B',
    overflow: 'hidden',
    width: '100%',
    whiteSpace: 'nowrap'
  },
  agenda: {
    color: '#212D40',
    fontSize: 18,
    fontWeight: 'bold',
    textAlign: 'left',
    marginTop: 10,
    '&:hover': {
      cursor: 'pointer'
    }
  },
  hover: {
    backgroundColor: '#EEF4FD',
    color: '#212D40',
    '&:hover': {
      cursor: 'pointer'
    }
  },
  icons: {
    position: 'absolute',
    right: -160,
    marginTop: 5
  },
  icon: {
    marginLeft: 5,
    '&:hover': {
      background: '#e0e0e0',
      borderRadius: 5
    }
  },
  doneBtn: {
    margin: 0,
    padding: 0,
    height: 22,
    background: '#697683',
    borderRadius: 4,
    color: '#fff',
    fontSize: 9,
    marginTop: -13,
    marginLeft: 5,
    '&:hover': {
      background: '#343B43'
    }
  },
  hidden: {
    display: 'none'
  },
  textField: {
    width: '100%',
    "& .MuiOutlinedInput-inputMarginDense": {
      margin: "0!important",
      border: '1px solid #697683',
      padding: 2,
      borderRadius: 3,
      paddingLeft: 6
    }
  },
  ml: {
    right: -80
  },
  textarea: {
    width: '100%',
    padding: 12
  },
  btn: {
    padding: '6px 27px',
    background: '#017AEF',
    color: '#fff',
    '&:hover': {
      background: '#0f9fef',
      color: '#fff',
    },
    textTransform: 'none'
  },
  label: {
    "&$focusedLabel": {
      color: "#707070"
    },
    "&$erroredLabel": {
      color: "#707070"
    }
  },
  focusedLabel: {
    fontSize: 14,
    fontFamily: 'roboto-black',
  },
  erroredLabel: {},
  underline: {
    fontSize: 14,
    fontFamily: 'roboto-regular',
    color: '#8F99A3',
    "&$error:after": {
      borderBottomColor: "#017AEF"
    },
    "&:after": {
      borderBottom: `1px solid #017AEF`
    }
  },
  error: {},
  calendarBtnLabel: {
    fontSize: 16,
    fontFamily: 'roboto-regular',
    textTransform: 'none'
  },
  csvBtn: {
    width: 100,
    height: 37,
    borderRadius: 4,
    backgroundColor: '#F0F0F0',
    fontSize: '0.875rem',
    fontFamily: 'roboto-regular',
    color: '#697683',
    alignItems: 'center',
    display: 'flex',
    justifyContent: 'center',
    boxShadow: '0px 3px 1px -2px rgba(0,0,0,0.2), 0px 2px 2px 0px rgba(0,0,0,0.14), 0px 1px 5px 0px rgba(0,0,0,0.12)',
    '& input': {
      display: 'none'
    },
    '&:hover': {
      cursor: 'pointer',
      backgroundColor: '#e0e0e0',
    },
  },
  csvLabel: {
    cursor: 'pointer',
    padding: 8
  },
  addAgendaHover: {
    '&:hover': {
      color: '#0f9fef'
    }
  },
  downloadicon: {
    marginLeft: 5,
    borderRadius: 5,
    background: '#F0F0F0',
    '&:hover': {
      background: '#e0e0e0',
      borderRadius: 5
    },
  },
  p7: {
    padding: 7
  }
}));

interface IAgendaItem {
  title: string
  marker_id: any
}
let message = "";

function AddAgenda(props: any) {
  const classes = useStyles();
  const [initStepHover, setInitStepHover] = useState(-1);
  const [editIndex, setEditIndex] = useState(-1);
  const [schedules, setSchedules] = useState<IAgendaItem[]>([]);
  const textAreaRef = useRef<any>(null);
  const parseOptions = {
    header: false,
    skipEmptyLines: true
  };
  const { onChange, onRemoveIds } = props;
  const { overviewAgendas } = useSelector((state: any) => state.creatorExperienceManager);
  const [isShownSnackAlert, setShownSnackAlert] = useState(false);
  const [csvData, handleCsvData] = useState<any[]>([]);
  const [randomID, setRendomId] = useState(1);

  const csvHeaders = [
    { label: "No", key: "no" },
    { label: "Agenda Name", key: "agenda_name" },
  ];

  const setOnChangeTitle = (e: any, index: number) => {
    const old: any = [...schedules];
    old[index][e.target.name] = e.target.value;
    onSaveSchedules(old);
    onChange(old)
  };

  const removeItem = (item: any, index: number) => {
    const old = [...schedules];
    old.splice(index, 1);
    onSaveSchedules(old);
    onChange(old, item.marker_id)
  };

  const addItem = () => {
    const old = [...schedules];
    old.push({
      title: 'Agenda Item Name',
      marker_id: null
    });
    onSaveSchedules(old);
    onChange(old);
    setEditIndex(schedules.length)
  };

  const onSaveSchedules = (old: IAgendaItem[]) => {
    setSchedules([...old]);
  };

  const handleOnDragEnd = (result: any) => {
    setEditIndex(-1);
    if (!result.destination) return;
    const items = Array.from(schedules);
    const [reorderedItem] = items.splice(result.source.index, 1);
    items.splice(result.destination.index, 0, reorderedItem);
    onSaveSchedules(items);
    onChange(items)
  };

  useEffect(() => {
    if (schedules.length === 0 && overviewAgendas.length > 0) {
      const item: any[] = [];
      overviewAgendas.forEach((row: any) => {
        item.push({
          title: row.marker_title,
          marker_id: row.marker_id
        })
      });
      setSchedules(item)
    }
  }, [overviewAgendas]);

  const handleForceCSV = (rows: any,fileInfo:any) => {
    const array = ['application/vnd.ms-excel','text/plain','text/csv','text/tsv'];
    if (array.indexOf(fileInfo.type) === -1) {
      message = Messages.NOTIFICATIONS.ERROR.csvFileValidation;
      setShownSnackAlert(true);
      return
    }
    const old: any = [];
    let skippedRows = 0;

    rows.forEach((row: any, index: number) => {
      if (index !== 0) { // CSV Header
        if (row[0] && row[1]) {
          old.push({
            title: row[1],
            marker_id: null
          })
        } else {
          skippedRows++
        }
      }

    });

    if (old.length === 0) {
      message = Messages.NOTIFICATIONS.ERROR.blankCsvError;
      setShownSnackAlert(true);
      setRendomId(randomID+1);
      return
    }

    onRemoveIds(schedules.filter((item: any) => item.marker_id).map((item: any) => item.marker_id));

    setSchedules(old);
    onSaveSchedules(old);
    props.onChange(old);
    if (skippedRows) {
      message = `${skippedRows} rows skipped.`;
      setShownSnackAlert(true)
    }
    setRendomId(randomID + 1)
  };

  const hideSnackAlert = () => {
    setShownSnackAlert(false);
  };

  const handleCSVDownload = () => {
    handleCsvData(schedules.map((item: any, index: number) => {
      return {
        no: index + 1,
        agenda_name: item?.title
      }
    }));
  };

  return (
    <>

      <Box alignItems="center" display="flex" flexDirection='column'>

        <form>
          <textarea
            ref={textAreaRef}
            style={{ position: 'absolute', left: -10000 }}
          />
        </form>

        {
          <div className={classes.table} style={schedules.length === 0 ? { borderWidth: 0 } : {}}>
            {schedules.length > 0 && <>
              <DragDropContext onDragEnd={handleOnDragEnd}>
                <Droppable droppableId="characters">
                  {(provided: any) => (
                    <div className="characters" {...provided.droppableProps} ref={provided.innerRef}>
                      {
                        schedules.map((item, index) =>
                          <Draggable key={index} draggableId={index + ""} index={index}>
                            {(provided: any) => (
                              <div
                                ref={provided.innerRef} {...provided.draggableProps} {...provided.dragHandleProps}
                                className={clsx(classes.tr, initStepHover === index && classes.hover)}
                                onMouseOver={() => setInitStepHover(index)}
                              >
                                <div className={classes.td} onDoubleClick={() => { setEditIndex(index) }}>
                                  {editIndex !== index && item.title}
                                  {
                                    editIndex === index &&
                                    <TextField
                                      className={classes.textField}
                                      value={item.title}
                                      size="small"
                                      variant="outlined"
                                      name="title"
                                      onChange={(e) => setOnChangeTitle(e, index)}
                                    />
                                  }
                                </div>
                                {/* <div className={classes.td} onDoubleClick={()=>{setEditIndex(index)}}>
                                  {editIndex !== index && `${item.start}-${item.end}`}
                                  {
                                    editIndex === index &&
                                    <>
                                      {displayDate(item,index)}
                                    </>
                                  }
                                </div> */}
                                <div className={clsx(classes.icons, initStepHover !== index && classes.hidden, editIndex !== index && classes.ml)}>
                                  <img src={'/assets/icons/experiencebuilder/edit-icon.svg'} alt="{}" className={classes.icon} onClick={() => setEditIndex(index)} />
                                  <img src={'/assets/icons/experiencebuilder/trash-icon.svg'} alt="{}" className={classes.icon} onClick={() => removeItem(item, index)} />
                                  {editIndex === index && <Button className={classes.doneBtn} onClick={() => setEditIndex(-1)}>DONE</Button>}
                                </div>
                              </div>
                            )}

                          </Draggable>
                        )

                      }
                      {provided.placeholder}
                    </div>
                  )}
                </Droppable>
              </DragDropContext>

            </>}

          </div>
        }

        <Box display="flex" justifyContent='center' flexDirection='row' style={{ minWidth: 400, marginTop: 15 }}>
          <div className={classes.titleBox}>
            <p className={`${classes.agenda} ${classes.addAgendaHover}`} onClick={addItem}>+ agenda item</p>
          </div>
          <div className={classes.titleBox}>

          </div>
          <div className={classes.titleBox} key={randomID}>
            <CSVReader
              cssClass={classes.csvBtn}
              cssLabelClass={classes.csvLabel}
              label="Upload CSV"
              onFileLoaded={handleForceCSV}
              parserOptions={parseOptions}
            />
            <CSVLink data={csvData} headers={csvHeaders} onClick={handleCSVDownload} filename={`agenda.csv`}>
              <div className={clsx(classes.downloadicon)}>
                <Tooltip title="Download CSV Template" placement="bottom">
                  <IconButton aria-label="download" className={classes.p7} size="medium">
                    <img src={'/assets/icons/download_icon.svg'} alt="CSV Download" />
                  </IconButton>
                </Tooltip>
              </div>
            </CSVLink>
          </div>
          <CustomSnackBar type={"error"} message={message} open={isShownSnackAlert} onClose={hideSnackAlert} />
        </Box>

      </Box>

    </>
  )
}

export default AddAgenda;
